var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 14,
    viewBox: "0 0 7 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location Pin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9554 11.1785C3.71073 11.4379 3.29406 11.4361 3.053 11.1734C1.71069 9.71041 -0.103624 7.77814 0.00462613 5.69542C0.202456 3.804 1.69241 2.33398 3.50109 2.33398C5.30976 2.33398 6.79972 3.804 6.99754 5.69542C7.07287 7.98993 5.40101 9.64599 3.9554 11.1785Z",
    fill: "#7C8593"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 10",
    d: "M4.66634 5.83268C4.66634 6.47701 4.14401 6.99935 3.49967 6.99935C2.85534 6.99935 2.33301 6.47701 2.33301 5.83268C2.33301 5.18835 2.85534 4.66602 3.49967 4.66602C4.14401 4.66602 4.66634 5.18835 4.66634 5.83268Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPin);
export default __webpack_public_path__ + "static/media/location-pin.245739afab460d82eb8506c7ae48d9e0.svg";
export { ForwardRef as ReactComponent };